export type TermsSectionBlock =
  | { titleId: string; paragraphId: string }
  | { titleId: string; listIds: readonly string[] };

export const TERMS_SECTION_CONFIG: TermsSectionBlock[] = [
  { titleId: 'certificates.terms.s1.title', paragraphId: 'certificates.terms.s1.body' },
  {
    titleId: 'certificates.terms.s2.title',
    listIds: [
      'certificates.terms.s2.li1',
      'certificates.terms.s2.li2',
      'certificates.terms.s2.li3',
      'certificates.terms.s2.li4',
    ],
  },
  {
    titleId: 'certificates.terms.s3.title',
    listIds: [
      'certificates.terms.s3.li1',
      'certificates.terms.s3.li2',
      'certificates.terms.s3.li3',
      'certificates.terms.s3.li4',
    ],
  },
  {
    titleId: 'certificates.terms.s4.title',
    listIds: [
      'certificates.terms.s4.li1',
      'certificates.terms.s4.li2',
      'certificates.terms.s4.li3',
    ],
  },
  { titleId: 'certificates.terms.s5.title', paragraphId: 'certificates.terms.s5.body' },
  {
    titleId: 'certificates.terms.s6.title',
    listIds: [
      'certificates.terms.s6.li1',
      'certificates.terms.s6.li2',
      'certificates.terms.s6.li3',
    ],
  },
];
